import { useContext } from "react";
import { PlanContext } from "../PlanForm";

const IncPoView = () => {
  const { originalPlan } = useContext(PlanContext);

  return (
    <div className="-mx-2">
      <table>
        <thead>
          <tr>
            <th colSpan={2}>Purchase Order Info</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <label>Vendor: </label>
            </td>
            <td className="w-full">Waboba AB</td>
          </tr>
          <tr>
            <td>
              <label>Delivery to: </label>
            </td>
            <td className="w-full">
              {originalPlan.planType === "INC_FOB_ORDER"
                ? "WH-DS / Stock"
                : "Oversea Inventory / Stock"}
            </td>
          </tr>
          <tr>
            <td>
              <label>Incoterm: </label>
            </td>
            <td>EX WORKS</td>
          </tr>
          <tr>
            <td>
              <label>Payment Terms: </label>
            </td>
            <td>NET 120 Days</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default IncPoView;
